import { RestService, API, getParentAppApiPath } from './lib';

class DatasourceService extends RestService {
  getAll = (ids = {}, params = {}) => {
    const url = getParentAppApiPath(API.DATASOURCES, ids, params);
    return this.sendRequest(url);
  };
}

export const datasourceService = new DatasourceService();
